/* ================================================================ */
// ROW EDITOR | RowEditor.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React, {useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Hooks
import useReactRouter from 'use-react-router';
import { useDispatch, useSelector } from 'react-redux';
// Material UI
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import makeStyles from '@material-ui/styles/makeStyles';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import usePrevious from '@myglobe/core/dist/hooks/usePrevious';
// React Grid editor
import { AutoSizer } from 'react-virtualized';
import ReactDataGrid, {SelectColumn, DataGridHandle, CalculatedColumn } from 'react-data-grid';
import 'react-data-grid/dist/react-data-grid.css';
import { ImageFormatter } from '../Admin/CellFormatters/ImageFormatter';
import ImageEditor from '../Admin/CellEditors/ImageEditor';
import {isNullOrUndefined} from 'util';
// Actions
import {updateDataset} from '../../actions/Data/Datasets';
// Local Components
import Save from '../Admin/Save';
import FieldEditor from '../Admin/FieldEditor';
import Field from '../Admin/FieldEditor/Field';
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(theme => ({
    root: {
        //minHeight:'400px',
        width: '100%',
        height: '70vh',
    },
    table: {
        color: theme.palette.common.black,
        height: '70vh',
        //minWidth: 650,
    },
    tableRow: {
        height: '1em',
        overflow: 'hidden'
    },
    control: {
        justifyContent: 'space-between',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%'
    },
    filename: {
        fontSize: '1.1rem',
        fontWeight: 'bold'
    },
    lastUpdated: {
        fontSize: '1rem',
        marginRight: '1rem'
    },
    addRowDialog: {
        width: '75%',
        height: '50vh',
    },
    buttonCont:{
        display:'flex',

    },
    addRowButton: {
        marginTop:'.5em',
        // width: '7em'
    }
}));

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}
const RowEditor = (props) => {
    const classes = useStyles();
    const [authState, setAuthState] = useState(props.authState);
    const [datasetID, setDatasetID] = useState(props.datasetID);
    const data = useSelector(state => state.Data.datasets.byHash[datasetID]);
    const dispatch = useDispatch();
    const [dataChanged, setDataChanged] = useState(false);
    const [rows, setRows] = useState(null);
    const prevRows = usePrevious(rows);
    const [cols, setCols] = useState(null);    
    const [selectedRows, setSelectedRows] = useState(() => new Set());
    const gridRef = useRef();
    const [loading, setLoading] = useState(false);
    const [addRowOpen, setAddRowOpen] = useState(false);

    const cellUpdate = (rowUpdateEvt)=>{
        const rowInd=rowUpdateEvt.fromRow, update = rowUpdateEvt.updated;
        const updatedRows = [...rows];
        updatedRows[rowInd] = {...updatedRows[rowInd],...update};
        setRows(updatedRows);
        setDataChanged(true);
    };
    const saveData = useCallback(()=>{
        console.log('save data',props);
        setLoading(true);
        let rowsForUpload = [...rows];
        rowsForUpload.forEach(x=>delete x._id);
        dispatch(updateDataset(data.endpoint,rows));
        
        //maybe dont bother sending up?
        //props.handleDataUpload(rows);
    });
    const handleRowClick = useCallback((rowIdx, row, column) => {
        //if (column.key === 'title') {
        // console.log('here',rowIdx, row, column);
        //   gridRef.current?.selectCell({ rowIdx, idx: column.idx }, true);
        //}
      }, []);
      
    useEffect(()=>{
        console.log('DATA CHANGE',data);
        if(data&&data.config) {
            let c = Object.keys(data.config).map((key)=>{
                let formatter;
                let editor = null;
                switch(data.config[key]){
                case 'media':
                    formatter= ({row,a}) => <ImageFormatter value={'https://gea2.myglobe.app/uploads/gea/media/'+row[key]} cell={key} row={row} />;
                    editor = React.forwardRef((props, ref) => { return <ImageEditor ref={ref}  type={data.config[key]} {...props} />;});
                    break;
                default:
                    formatter= ({row}) => row[key];
                    editor = React.forwardRef((props, ref) => { return <FieldEditor ref={ref} label={key} type={data.config[key]} value={props.row[key]} {...props} />;});
                    break;
                }
                return {
                    key,
                    name:key,
                    editable:true,
                    ... (formatter && {formatter}),
                    ... (editor && {editor}),
                    type: data.config[key]
                };
            });
            c.unshift({key:"_id",
                name:"ID",
                editable:false});
            c.unshift(SelectColumn);  

            setCols(c);
        }
        if(data&&data.endpointData){
            data.endpointData.forEach((x,i)=>x._id=i);
            setRows(data.endpointData);
        }

    },[data]);    
    /**
     * Open Add Row Dialog
     * -------------------
     * Opens add row dialog form
     */
    const handleAddRowDialog = () => {
        //Open Dialog
        //setAddRowOpen(true);
        const emptyRow = cols?.reduce((map, value) => {
            const key = value['key'];
            map[key] = '';
            return map;
        }, {});
        emptyRow._id = rows.length;                
        setRows([...rows,emptyRow]);
    };
    // scroll to end if new row added
    useEffect(()=>{
        if(rows && prevRows && prevRows.length < rows.length)
            gridRef.current.scrollToRow(rows.length);
    },[rows]);
    const handleAddRow = (newRow) => {
        //const index = rows.length;
        const updatedRows = [...rows, newRow];
        setRows(updatedRows);
        setAddRowOpen(false);
    };
    // const handleCancelAddRow = () => {
    //     setAddRowOpen(false);
    // };
    const handleDeleteRow = useCallback((args) =>{        
        //open confirm dialog
        setRows(rows.filter(x=>![...selectedRows].includes(x._id) ));
        setSelectedRows(() => new Set());//selectedRows.clear();
    });
    
    return (
        <div className={classes.root}>
            {data &&
                <div className={classes.control}>
                    <Save filename={data.name} isSaved={!dataChanged} onSave={saveData} /*onSaveAs={}*/ />
                    <Typography className={classes.filename}>{data.name}</Typography>
                    <Typography className={classes.lastUpdated}>{`Last Updated ${new Date(data.lastUpdated).toLocaleDateString('en-GB', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'})}`}</Typography>
                </div>
            }
            {rows!=null&&cols!=null&&                
            <AutoSizer>
                {({ width, height }) => (
                    <div className={classes.table} style={{width}}>
                        <ReactDataGrid
                            rowKey="_id"
                            columns={cols}
                            rows={rows}
                            width={width}
                            height={height}
                            rowHeight={32}
                            onRowsUpdate={cellUpdate}
                            ref={gridRef}
                            //onRowClick={handleRowClick}
                            selectedRows={selectedRows}
                            onSelectedRowsChange={setSelectedRows}
                        />
                        <div className={classes.control}>
                        <Button
                            onClick={handleAddRowDialog}
                            className={classes.addRowButton}
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<AddIcon />}
                        >
                            Add Row
                        </Button>
                        <Button 
                            onClick={handleDeleteRow}
                            className={classes.addRowButton}
                            color="error"
                            variant="contained"
                            size="small"
                            disabled={selectedRows.size==0}
                            startIcon={<DeleteIcon />}
                        >Delete</Button>
                        </div>                            
                    </div>                    
                )}
            </AutoSizer>                    
            }
            {/* <AddRowDialog isOpen={addRowOpen} columns={cols} onSubmit={handleAddRow} onCancel={handleCancelAddRow} /> */}
        </div>
    );
};
export default RowEditor;

/* ========================================== */
/**
 * Add Row Dialog
 * --------------
 * New row field editor form
 * 
 * @param {object} props component props
 * @param {bool} props.isOpen dialog open state
 * @param {array} props.column datagrid columns
 * @param {func} props.onSubmit form submit callback
 * @param {func} props.onCancel form cancel callback 
 */
const AddRowDialog = ({
    isOpen,
    columns,
    // Functions
    onSubmit,
    onCancel
}) => {
    const classes = useStyles();
    const [row, setRow] = useState([]);
    const formGridRef = useRef();
    useEffect(()=>{
        // Init empty row
        const emptyRow = columns?.reduce((map, value) => {
            const key = value['key'];
            map[key] = '';
            return map;
        }, {});
        console.log(emptyRow);
        setRow([emptyRow]);
    }, [columns]);
    const handleValueUpdate = (key, value) => {
        setRow({...row, [key]: value});
    };
    const handleComplete = () => {
        onSubmit && onSubmit(row);
    };
    const handleClose = () => {
        onCancel && onCancel();
    };    
    const cellUpdate = (rowUpdateEvt)=>{
        const rowInd=rowUpdateEvt.fromRow, update = rowUpdateEvt.updated;
        const updatedRows = [...row];
        updatedRows[rowInd] = {...updatedRows[rowInd],...update};
        setRow(updatedRows);
    };
    
    return (
        <Dialog classes={{paper:classes.addRowDialog}} open={isOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">New Row</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Add a new row to the dataset
                </DialogContentText>
                {row!=null&&columns!=null&&
                <AutoSizer>
                    {({ width, height }) => (
                        <div className={classes.table}>
                            <ReactDataGrid
                                columns={[...columns]}
                                rows={row}
                                width={width}
                                height={80}
                                rowHeight={32}
                                onRowsUpdate={cellUpdate}
                                ref={formGridRef}
                            />
                        </div>
                    )}
                </AutoSizer>
                }
                {/*columns?.filter(col=>!isNullOrUndefined(col.name) && col.name.length !== 0).map(col=>
                    col.type === 'media' ?
                        <ImageEditor type={col.type} column={col} onUpdate={(value)=>handleValueUpdate(col.key, value)} />
                        :   
                        <Field
                            key={`${col.key}-field`}
                            label={col.name}
                            type={col.type}
                            value={''}
                            onUpdate={(value)=>handleValueUpdate(col.key, value)}
                        />
                )*/}                
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Cancel
                </Button>
                <Button onClick={handleComplete} color="primary" variant="contained">
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
};
AddRowDialog.propTypes= {
    isOpen: PropTypes.bool.isRequired,
    columns: PropTypes.arrayOf(PropTypes.object),
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func
};